var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclaIconGreenNow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1953 22.0586C17.7182 22.0586 22.1953 17.5814 22.1953 12.0586C22.1953 6.53575 17.7182 2.05859 12.1953 2.05859C6.67246 2.05859 2.19531 6.53575 2.19531 12.0586C2.19531 17.5814 6.67246 22.0586 12.1953 22.0586Z",
    stroke: "#34A853",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6477 14.3846L11.5789 7.50547H12.8171L12.7483 14.3846H11.6477ZM12.198 17.9618C11.9611 17.9618 11.7585 17.8777 11.5903 17.7096C11.4222 17.5414 11.3381 17.3389 11.3381 17.1019C11.3381 16.8573 11.4222 16.6548 11.5903 16.4942C11.7585 16.3261 11.9611 16.242 12.198 16.242C12.4426 16.242 12.6451 16.3261 12.8057 16.4942C12.9738 16.6548 13.0579 16.8573 13.0579 17.1019C13.0579 17.3389 12.9738 17.5414 12.8057 17.7096C12.6451 17.8777 12.4426 17.9618 12.198 17.9618Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaIconGreenNow);
export default __webpack_public_path__ + "static/media/excla-icon-green-now.6b8a71b9389b58d8e2b95afc9261e7c2.svg";
export { ForwardRef as ReactComponent };